<div class="table-container" [attr.data-testid]="testIds.tableContainer">
  <table
    mat-table
    [dataSource]="isLoading() ? skeletonData : data"
    multiTemplateDataRows
    class="generic-table"
    matSort
    [matSortActive]="activeSortKey()"
    matSortDisableClear
    matSortDirection="desc"
    (matSortChange)="onSortChange($event)"
    [attr.data-testid]="testIds.genericTable">
    @for (col of displayedColumnsSignal(); track $index) {
      <ng-container [matColumnDef]="col.key">
        @if (col.sortable) {
          <th mat-header-cell [attr.data-testid]="col.label" *matHeaderCellDef mat-sort-header disableClear>
            {{ col.label }}
          </th>
        } @else {
          <th mat-header-cell [attr.data-testid]="col.label" *matHeaderCellDef>
            {{ col.label }}
          </th>
        }

        <td mat-cell *matCellDef="let element" [attr.data-testid]="'cell_' + $index + '_' + col.key">
          @if (!isLoading()) {
            @switch (col.type) {
              @case ('date') {
                <span>{{ element[col.key] | date: 'dd.MM.yyyy HH:mm' }}</span>
              }
              @case ('custom') {
                <ng-container *ngTemplateOutlet="col.template!; context: { $implicit: element }"></ng-container>
              }
              @case ('checkbox') {
                <div class="checkbox-wrapper">
                  <mat-checkbox
                    class="tim-checkbox"
                    (change)="emitRow(element, $event)"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    [attr.data-testid]="testIds.checkboxRowSelect"></mat-checkbox>
                  <span class="clamp-text">{{ element[col.key] }}</span>
                </div>
              }
              @default {
                <span>{{ element[col.key] }}</span>
              }
            }
          } @else {
            <ngx-skeleton-loader count="1" [theme]="{ width: '100%', height: '1rem' }"></ngx-skeleton-loader>
          }
        </td>
      </ng-container>
    }
    <!-- Expand-Detail-Spalte -->
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.data-testid]="'cell_' + element.id"
        [attr.colspan]="columnsToDisplayExpanded.length"
        class="detail-wrapper">
        @if (isExpanded(element)) {
          @if (expandedTemplate(); as templateRef) {
            <ng-container *ngTemplateOutlet="templateRef; context: { $implicit: element }"></ng-container>
          }
        }
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
      class="table-header"
      [attr.data-testid]="testIds.tableHeaderRow"></tr>
    <!--- Normale Zeile ---->
    <tr
      mat-row
      *matRowDef="let element; columns: displayedColumns"
      class="element-row"
      [class.expanded-row]="isExpanded(element)"
      [class.clicked-row-checkbox]="clickedCheckboxRows.has(element)"
      [class.clicked-row]="clickedRow === element"
      tabindex="0"
      (keydown.enter)="toggleRow(element)"
      (click)="toggleRow(element)"
      [attr.data-testid]="'table_row_' + element.id"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    <tr class="mat-row no-data" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <span [attr.data-testid]="testIds.tableNodataText">Keine Daten vorhanden.</span>
      </td>
    </tr>
  </table>
  @if (showPaging()) {
    <mat-paginator
      [length]="totalItems()"
      [pageSize]="pageSize()"
      [pageIndex]="pageIndex()"
      [showFirstLastButtons]="showFirstLastButtons"
      [pageSizeOptions]="pageSizeOptions"
      (page)="paginatorChange($event)"
      class="table-paginator"
      [attr.data-testid]="testIds.tablePaginator"></mat-paginator>
  }
</div>
